actionFormPage = function () {
  $(".dmca__add-link").on("click", function () {
    if ($(this).index() <= 100) {
      $(this).before(
        '<input type="text" style="width: 100%; margin-top: 10px;" placeholder="Links to the allegedly infringing work" aria-label="input" name="contact[infringing_work]" class="input-full form-control"><label class="dmca__error">This field is required</label>'
      );
    }
    return false;
  });

  $(".checkbox-inline input").on("click", function () {
    if ($(this).is(":checked")) {
      $(this).val("true");
      $(this).siblings(".statements_validate").hide();
    } else {
      $(this).val("false");
      $(this).siblings(".statements_validate").show();
    }
  });

  $("body").on("click", '[name="ftc"]', function () {
    let flag = true;
    let $thisSubmit = $(this);
    $(".checkbox-inline input").each(function () {
      if ($(this).is(":checked") || $(this).val() === true) {
        $thisSubmit.submit();
      } else {
        $(this).siblings(".statements_validate").show();
        flag = false;
      }
    });

    $(".form-control").each(function () {
      if ($(this).val().trim() == "") {
        $(this).siblings(".dmca__error").show();
        $("html, body").animate(
          {
            scrollTop: $("#ContactFormName").offset().top,
          },
          500
        );
        flag = false;
      } else {
        $(this).siblings(".dmca__error").hide();
      }
    });
    return flag;
  });

  $("body").on("keyup", ".form-control", function () {
    if ($(this).val().trim() !== "") {
      $(this).siblings(".dmca__error").hide();
    } else {
      $(this).siblings(".dmca__error").show();
    }
  });

  $(".form-dropdown").on("change", function () {
    let el = $(this);
    let checked = el.find(":checked");

    $("#id_9 #text_9").html(checked.text());

    if (checked.val() != "") {
      $(".form-hide").hide().find("textarea").attr("disabled", true);
      $("#id_9").show();

      const dropdownOption = $('[data-type="dropdown-option"]');
      const showInput = checked.data('show');
      console.log(showInput, "showInput")
      if(showInput){
        dropdownOption.removeAttr("disabled").attr('name', `contact[${checked.val()}]`).parent().show();
      }
    } else {
      $(".form-hide").hide();
    }


    if (checked.val() === "edit order design") {
      $("#id_11").show().find("#input_11").removeAttr("disabled");
    } else if (checked.val() === "edit order variant") {
      $("#id_16").show().find("#input_16").removeAttr("disabled");
    } else if (checked.val() === "Change shipping address") {
      $("#id_19").show().find("#input_19").removeAttr("disabled");
    } else if (checked.val() === "Change product quantity") {
      $("#id_21").show().find("#input_21").removeAttr("disabled");
    } else if (checked.val() === "Cancel order") {
      $("#id_24").show().find("#input_24").removeAttr("disabled");
    }
  });
};
actionFormPage();
